import { Model } from './Model';
import { TranslatableDict, TranslatableField } from './TranslatableField';

export enum FeedbackTypeEnum {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
}

export const FEEDBACK_TYPES_IN_ORDER: FeedbackTypeEnum[] = [
  FeedbackTypeEnum.POSITIVE,
  FeedbackTypeEnum.NEGATIVE,
  FeedbackTypeEnum.NEUTRAL,
];

export interface Feedback extends Model {
  type: FeedbackTypeEnum;
  title: TranslatableField;
  message: TranslatableField;
}

export type FeedbackCreateDTO = {
  id?: number;
  type?: FeedbackTypeEnum;
  title?: TranslatableDict;
  message?: TranslatableDict;
};
